import React from 'react';
import './ProductFormByType.css';

/**
 * Luft & Klima-spezifisches Formular
 * Blanko-Formular für Lüftungs- und Klimakontrollsysteme
 */
function ClimateForm({ formData, handleChange, disabled }) {
  return (
    <div className="product-type-form-section">
      <h3>🌬️ Luft & Klima-Spezifikationen</h3>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="airFlowRate">📐 Luftstromstärke (m³/h)</label>
          <input
            type="number"
            id="airFlowRate"
            name="airFlowRate"
            value={formData.airFlowRate || ''}
            onChange={handleChange}
            placeholder="z.B. 1000"
            step="0.1"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label htmlFor="noiseLevel">🔊 Lautstärke (dB)</label>
          <input
            type="number"
            id="noiseLevel"
            name="noiseLevel"
            value={formData.noiseLevel || ''}
            onChange={handleChange}
            placeholder="z.B. 65"
            step="0.1"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="powerConsumption">⚡ Stromverbrauch (Watt)</label>
          <input
            type="number"
            id="powerConsumption"
            name="powerConsumption"
            value={formData.powerConsumption || ''}
            onChange={handleChange}
            placeholder="z.B. 60"
            step="0.1"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label htmlFor="temperatureControl">🌡️ Temperaturkontrolle</label>
          <select
            id="temperatureControl"
            name="temperatureControl"
            value={formData.temperatureControl || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="Manuell">Manuell</option>
            <option value="Automatisch">Automatisch</option>
            <option value="Smart-Control">Smart-Control</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="humidityControl">💧 Feuchtigkeitskontrolle</label>
          <select
            id="humidityControl"
            name="humidityControl"
            value={formData.humidityControl || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="Manuell">Manuell</option>
            <option value="Automatisch">Automatisch</option>
            <option value="Smart-Control">Smart-Control</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="connections">🔌 Anschlusstypen</label>
          <input
            type="text"
            id="connections"
            name="connections"
            value={formData.connections || ''}
            onChange={handleChange}
            placeholder="z.B. 230V, 400V, USB"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="tankVolume">🪣 Tankvolumen (Liter)</label>
          <input
            type="number"
            id="tankVolume"
            name="tankVolume"
            value={formData.tankVolume || ''}
            onChange={handleChange}
            placeholder="z.B. 5"
            step="0.1"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="climateSmartControl"
              checked={formData.climateSmartControl || false}
              onChange={handleChange}
              disabled={disabled}
            />
            <span>📱 Smartsteuerung / App-Steuerung</span>
          </label>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="climateDescription">Spezielle Features (optional)</label>
        <textarea
          id="climateDescription"
          name="climateDescription"
          value={formData.climateDescription || ''}
          onChange={handleChange}
          placeholder="z.B. Co2-Regler, Aktivkohlefilter, Geruchsvernichtung..."
          rows="3"
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default ClimateForm;
